<template>
    <div class="robot-export-model">
        <TitleBaseBox class="robot-export-box" :title="data.title" :noButton="true" @close="close">
            <Tabs :tabs-config="tabsConfig" @tabClick="tabClick">
                <component :is="currentComponentName" :get-export-list="data.getExport" />
            </Tabs>
        </TitleBaseBox>
    </div>
</template>
<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import ToDownLoadTab from "./ToDownLoadTab";
export default {
    name: "RobotExportExcel",
    props: ["data"],
    components: {
        TitleBaseBox,
        Tabs,
        ToDownLoadTab
    },
    data() {
        return {
            currentComponentName: "ToDownLoadTab",
            tabsConfig: [
                {
                    tabName: "下载记录",
                    contentName: "ToDownLoadTab"
                }
            ]
        };
    },
    methods: {
        close() {
            this.$emit("closeModal");
        },
        tabClick(data) {
            this.currentComponentName = data.componentName;
        }
    }
};
</script>
<style lang="less" scoped>
.robot-export-model {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .robot-export-box {
        width: 840px;
    }
    /deep/.title-base-mask {
        max-height: 80%;
    }
    /deep/.base-content {
        padding-top: 0;
    }
}
</style>
